import {
    Download,
    RefreshCw,
    ChevronRight,
    ShoppingBag,
    CalendarDays,
} from "lucide-react";

import "./OrderHeader.css";

function OrderHeader({
    totalOrders,
    onRefresh,
}) {

    const today = new Date().toLocaleDateString("en-IN", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
    });

    return (

        <div className="order-header">

            <div className="order-header-left">

                <div className="breadcrumb">

                    Dashboard

                    <ChevronRight size={16} />

                    Orders

                </div>

                <h1>

                    Order Management

                </h1>

                <p>

                    Monitor, track and manage customer orders,
                    provider updates and delivery progress.

                </p>

            </div>

            <div className="order-header-right">

                <div className="header-date">

                    <CalendarDays size={18} />

                    {today}

                </div>

                <div className="header-total">

                    <ShoppingBag size={22} />

                    <div>

                        <h2>{totalOrders}</h2>

                        <span>Total Orders</span>

                    </div>

                </div>

                <div className="header-buttons">

                    <button
                        className="refresh-btn"
                        onClick={onRefresh}
                    >

                        <RefreshCw size={18} />

                        Refresh

                    </button>

                    <button
                        className="export-btn"
                    >

                        <Download size={18} />

                        Export

                    </button>

                </div>

            </div>

        </div>

    );

}

export default OrderHeader;